import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template", "totalPercentage"];
  static values = { count: Number };

  connect() {
    this.countValue = 0;

    // Count existing beneficiaries
    const existingForms =
      this.containerTarget.querySelectorAll(".beneficiary-form").length;

    // Only add first beneficiary if there are no existing ones
    if (existingForms === 0) {
      this.addBeneficiary();
    } else {
      // Set count to start after existing beneficiaries
      this.countValue = existingForms;
      // Update percentage total for existing beneficiaries
      this.updatePercentageTotal();
    }

    this.updateRemoveButtons();
  }

  addBeneficiary() {
    const template = this.templateTarget;
    const content = template.content.cloneNode(true);
    const form = content.querySelector(".beneficiary-form");

    // Update field names with unique index
    this.updateFieldNames(form, this.countValue);

    this.containerTarget.appendChild(form);
    this.countValue++;
    this.updateRemoveButtons();
  }

  removeBeneficiary(event) {
    const form = event.target.closest(".beneficiary-form");
    if (!form) return;

    // Check if this is an existing beneficiary (has a hidden id field)
    const idField = form.querySelector('input[name*="[id]"]');
    const destroyField = form.querySelector('input[name*="[_destroy]"]');

    if (idField && destroyField) {
      // Mark for deletion instead of removing from DOM
      destroyField.value = "1";
      form.style.display = "none"; // Hide the form
    } else {
      // New beneficiary, just remove from DOM
      form.remove();
    }

    this.updateRemoveButtons();
    this.updatePercentageTotal();
  }

  updateFieldNames(form, index) {
    // Update all field names to use proper Rails nested attributes format
    form.querySelectorAll("input, select").forEach((field) => {
      if (field.name) {
        field.name = field.name.replace(
          /\[beneficiaries_attributes\]\[\d+\]/,
          `[beneficiaries_attributes][${index}]`
        );
      }
      if (field.id) {
        field.id = field.id.replace(
          /_beneficiaries_attributes_\d+_/,
          `_beneficiaries_attributes_${index}_`
        );
      }
    });
  }

  checkAge(event) {
    const dateField = event.target;
    const form = dateField.closest(".beneficiary-form");
    if (!form) return;

    const guardianSection = form.querySelector(
      '[data-beneficiaries-target="guardianSection"]'
    );
    if (!guardianSection) return;

    const dateOfBirth = new Date(dateField.value);
    const today = new Date();

    // Calculate age
    let age = today.getFullYear() - dateOfBirth.getFullYear();
    const monthDiff = today.getMonth() - dateOfBirth.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < dateOfBirth.getDate())
    ) {
      age--;
    }

    // Show/hide guardian section based on age
    if (age < 18) {
      guardianSection.classList.remove("hidden");
      // Add required attribute to guardian fields
      guardianSection.querySelectorAll("input").forEach((input) => {
        input.setAttribute("required", "required");
      });
    } else {
      guardianSection.classList.add("hidden");
      // Remove required attribute and clear guardian fields
      guardianSection.querySelectorAll("input").forEach((input) => {
        input.removeAttribute("required");
        input.value = "";
      });
    }
  }

  updateRemoveButtons() {
    const forms = this.containerTarget.querySelectorAll(
      ".beneficiary-form:not([style*='display: none'])"
    );
    const allForms = this.containerTarget.querySelectorAll(".beneficiary-form");

    allForms.forEach((form) => {
      const removeButton = form.querySelector(".remove-beneficiary");
      if (removeButton) {
        // Hide remove button if only one visible beneficiary
        removeButton.classList.toggle("hidden", forms.length <= 1);
      }
    });
  }

  updatePercentageTotal() {
    let total = 0;
    // Only count visible beneficiaries (not marked for deletion)
    this.containerTarget
      .querySelectorAll(
        '.beneficiary-form:not([style*="display: none"]) [data-beneficiaries-target="percentage"]'
      )
      .forEach((input) => {
        total += parseInt(input.value) || 0;
      });

    if (this.hasTotalPercentageTarget) {
      this.totalPercentageTarget.textContent = total;
      this.totalPercentageTarget.className =
        total === 100
          ? "total-percentage text-lg font-bold text-green-600"
          : total > 100
          ? "total-percentage text-lg font-bold text-red-600"
          : "total-percentage text-lg font-bold text-gray-800";
    }
  }
}
